import React, {Component} from "react";
import {motion} from "framer-motion";
import BGGraphic4 from "../img/graphics/BGGraphic4";

class TeamSection extends Component {

    render() {
        const cardWidth = this.props.mobile ? '100%' : 300
        const imageHeight = this.props.mobile ? 360 : 300
        return (
            <div className='body1 black-80 mt-100'>
                <div className='relative'>
                    <BGGraphic4 className='absolute black-10' width={this.props.mobile ? '22vw' : '12vw'} height={this.props.mobile ? '22vw' : '12vw'}
                                style={{right: 0, zIndex: 0, top: -40, transform: 'rotate(12deg)', opacity: .7}}/>
                    <motion.div
                        initial={{opacity: 0, transform: 'scale(1) translateY(8px)'}}
                        whileInView={{opacity: 1, transform: 'scale(1) translateY(-0%)'}}
                        transition={{default: {ease: "linear"}, delay: .2}}
                        className={this.props.mobile ? 'heading2 w-100p mb-20' : 'heading2 w-60p mb-20'}
                        style={{lineHeight: 1.4}}>
                        Meet our <i>founders</i>
                    </motion.div>
                </div>
                <motion.div
                    initial={{opacity: 0, transform: 'scale(1) translateY(8px)'}}
                    whileInView={{opacity: 1, transform: 'scale(1) translateY(-0%)'}}
                    transition={{default: {ease: "linear"}, delay: .2}}
                    className={this.props.mobile ? 'w-100p' : 'w-80p'}
                    style={{lineHeight: 1.8}}>
                    The Starfish team combines deep business experience, energetic vision, and world-class engineering talent. We've built a global ecosystem where people and causes come together to illuminate Good and inspire action. Our team continues to evolve because shepherding something meaningful never stops.
                </motion.div>
                <div className={this.props.mobile ? 'col-plain mt-40 flex-1' : 'row-plain mt-40 flex-1'}
                     style={{flexWrap: 'wrap', gap: this.props.mobile ? 24 : 20}}>
                    <motion.div
                        initial={{opacity: 0, transform: 'scale(1) translateY(8px)'}}
                        whileInView={{opacity: 1, transform: 'scale(1) translateY(-0%)'}}
                        transition={{default: {ease: "linear"}, delay: .4}}
                        className='mb-20'
                        style={{width: cardWidth}}>
                        <div style={{width: '100%', height: imageHeight, overflow: 'hidden', backgroundColor: '#F5F8FF'}}>
                            <img alt={'John Cervenka'} style={{objectFit: 'cover', width: '100%', height: '100%', display: 'block'}} src={require('../img/people/john.png')}/>
                        </div>
                        <div className='title1 black-80 mt-8'>
                            John Cervenka
                        </div>
                        <div className='body1 black-50' style={{fontStyle: 'italic'}}>
                            Founder | CEO
                        </div>
                    </motion.div>
                    <motion.div
                        initial={{opacity: 0, transform: 'scale(1) translateY(8px)'}}
                        whileInView={{opacity: 1, transform: 'scale(1) translateY(-0%)'}}
                        transition={{default: {ease: "linear"}, delay: .5}}
                        className='mb-20'
                        style={{width: cardWidth}}>
                        <div style={{width: '100%', height: imageHeight, overflow: 'hidden', backgroundColor: '#F5F8FF'}}>
                            <img alt={'Steven G. Mott'} style={{objectFit: 'cover', width: '100%', height: '100%', display: 'block'}} src={require('../img/people/stevemott.jpeg')}/>
                        </div>
                        <div className='title1 black-80 mt-8'>
                            Steven G. Mott
                        </div>
                        <div className='body1 black-50' style={{fontStyle: 'italic'}}>
                            Founder | COO
                        </div>
                    </motion.div>
                    <motion.div
                        initial={{opacity: 0, transform: 'scale(1) translateY(8px)'}}
                        whileInView={{opacity: 1, transform: 'scale(1) translateY(-0%)'}}
                        transition={{default: {ease: "linear"}, delay: .6}}
                        className='mb-20'
                        style={{width: cardWidth}}>
                        <div style={{width: '100%', height: imageHeight, overflow: 'hidden', backgroundColor: '#F5F8FF'}}>
                            <img alt={'Carey Lewis Mott'} style={{objectFit: 'cover', width: '100%', height: '100%', display: 'block'}} src={require('../img/people/careylewismott.jpeg')}/>
                        </div>
                        <div className='title1 black-80 mt-8'>
                            Carey Lewis Mott
                        </div>
                        <div className='body1 black-50' style={{fontStyle: 'italic'}}>
                            Founder | Advisory Board
                        </div>
                    </motion.div>
                </div>
                {/*<div className='mt-60'>*/}
                {/*     <motion.div*/}
                {/*        initial={{opacity: 0, transform: 'scale(1) translateY(8px)'}}*/}
                {/*        whileInView={{opacity: 1, transform: 'scale(1) translateY(-0%)'}}*/}
                {/*        transition={{default: {ease: "linear"}, delay: .2}}*/}
                {/*        className={this.props.mobile ? 'heading4 w-100p mb-20' : 'heading4 w-60p mb-20'}*/}
                {/*        style={{lineHeight: 1.4}}>*/}
                {/*        Advisory Board*/}
                {/*    </motion.div>*/}
                {/*    <motion.div*/}
                {/*        initial={{opacity: 0, transform: 'scale(1) translateY(8px)'}}*/}
                {/*        whileInView={{opacity: 1, transform: 'scale(1) translateY(-0%)'}}*/}
                {/*        transition={{default: {ease: "linear"}, delay: .4}}*/}
                {/*        className={this.props.mobile ? 'mb-20' : 'mr-20 mb-20'}*/}
                {/*        style={{width: this.props.mobile ? '100%' : 140}}>*/}
                {/*        <img style={{objectFit: 'cover'}} src={require('../img/people/john.png')}*/}
                {/*             width={this.props.mobile ? '100%' : 140} height={140}/>*/}
                {/*        <div className='body2-bold black-80'>*/}
                {/*            John Cervenka*/}
                {/*        </div>*/}
                {/*        <div className='body3 black-50' style={{fontStyle: 'italic', marginTop:-4}}>*/}
                {/*            Founder | CEO*/}
                {/*        </div>*/}
                {/*    </motion.div>*/}
                {/*</div>*/}
            </div>
        )
    }

}


export default TeamSection;
